import { V2ProjectsTable } from '../views/index';
import { ProjectDTO } from '../../../project/dtos/index';
import { DATE_MDY } from '../../../utils/date/index';
import { ANNUAL_VOLUME_DISPLAY } from '../../../project/utils/broker-projects-table';
import { PROJECT_STAGE_UUID } from '../../../project/constants/project-stage';
import { IS_NOT_EMPTY, IS_EMPTY } from '../../../utils/stringUtils/string-utils';
import { GET_LANE_PATH_STRING } from '../../../project/utils';

export const V2_PROJECTS = (
	projectDTOList: Array<ProjectDTO> = [],
	isAnnualVolumeEnabled: boolean = false,
	userId: number = null,
	usersList: Array<any> = []
): Array<V2ProjectsTable> => {
	let results: Array<V2ProjectsTable> = [];
	try {
		if (projectDTOList?.length > 0) {
			projectDTOList.map((projectDTO: ProjectDTO) => {
				const originCity = projectDTO.originCity,
					originState = projectDTO.originState,
					destCity = projectDTO.destCity,
					destState = projectDTO.destState;
				let project = {} as V2ProjectsTable;
				project.id = projectDTO.id;
				project.startDate = DATE_MDY(projectDTO.dueDate);
				project.originCity = originCity;
				project.originState = originState;
				project.destinationCity = destCity;
				project.destinationState = destState;
				project.customerName = projectDTO?.customerDTO?.name || '-';
				project.monthlyVolumeDisplay = 'N/A';
				const annualVolume = ANNUAL_VOLUME_DISPLAY(projectDTO);
				if (annualVolume) {
					project.monthlyVolumeDisplay = `${Math.round(annualVolume / 12)}/Month`;
				}
				project.equipment = projectDTO.equipmentType?.replace(',', ', ').toUpperCase();
				project.commodity = projectDTO.commodity;
				project.weight = projectDTO.weight;
				project.maxBuy = projectDTO.maxBuy;
				project.targetCarrierRate = projectDTO.bestRate;
				project.procuredCarriers = projectDTO.carrierCount;
				project.assignedReps = 'unassigned';
				if (projectDTO.assigneeId) {
					const userAssigned = usersList?.find((user) => user.userId == projectDTO.assigneeId);
					if (userAssigned) {
						project.assignedReps = userAssigned?.name;
					}
				}
				project.userId = projectDTO.userId;
				project.stageId = projectDTO.stageId;
				project.revenueCode = projectDTO.revenueCode;
				project.stageName = IS_NOT_EMPTY(project.stageId)
					? PROJECT_STAGE_UUID[project.stageId]
					: '';
				project.type = IS_NOT_EMPTY(projectDTO.type) ? projectDTO.type.charAt(0) : '';
				if (IS_NOT_EMPTY(originCity) && IS_NOT_EMPTY(originState)) {
					project.origin = `${originCity}, ${originState}`;
				}
				if (IS_NOT_EMPTY(destCity) && IS_NOT_EMPTY(destState)) {
					project.destination = `${destCity}, ${destState}`;
				}
				project.lanePath = GET_LANE_PATH_STRING(projectDTO);
				if (IS_EMPTY(project.lanePath)) {
					project.lanePath = '';
					if (IS_NOT_EMPTY(projectDTO.originCity)) {
						project.lanePath += `${projectDTO.originCity}, `;
					}
					if (IS_NOT_EMPTY(projectDTO.originState)) {
						project.lanePath += `${projectDTO.originState} `;
					}
					if (IS_NOT_EMPTY(projectDTO.destCity)) {
						project.lanePath += `${projectDTO.destCity}, `;
					}
					if (IS_NOT_EMPTY(projectDTO.destState)) {
						project.lanePath += `${projectDTO.destState} `;
					}
					if (IS_NOT_EMPTY(projectDTO.equipmentType)) {
						project.lanePath += `(${projectDTO.equipmentType})`;
					}
				}
				project.sendToOutOfNetworkCarriers = projectDTO.sendToOutOfNetworkCarriers;
				project.sendToOutOfNetworkCarriersDelay = projectDTO.sendToOutOfNetworkCarriersDelay;
				project.loadsCount = projectDTO.loadsCount;
				results.push(project);
			});
		}
	} catch (error) {
		console.log('V2_PROJECTS error: ', error);
	}

	return results;
};
